
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 72 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"a","cx":"54.17","cy":"63.17","r":"72.02","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ec991c"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#e9b213"}})])]),_c('path',{attrs:{"d":"M71.2 29l-15-26A6 6 0 0051 0H21a6 6 0 00-5.19 3L.8 29a6 6 0 000 6l15 26a6 6 0 005.2 3h30a6 6 0 005.19-3l15-26a6 6 0 00.01-6z","fill":"url(#a)"}})])
          )
        }
      }
    